import React, { PropsWithChildren, useContext, useMemo } from 'react';
import { FeatureName } from '../../types';
import { FeatureSecurityContext } from '../contexts/FeatureSecurityContext';

export type FeatureSecurityProviderProps = PropsWithChildren & {
    featureName: FeatureName;
};

export default function FeatureSecurityProvider({ featureName, children }: FeatureSecurityProviderProps) {
    const parentFeatureSecurity = useContext(FeatureSecurityContext);

    const contextValue = useMemo(() => {
        const parentFeatureNames = parentFeatureSecurity?.featureNames ?? [];

        const value = {
            // Keep nearest provider at index 0, then walk up the tree.
            featureNames: [featureName, ...parentFeatureNames]
        };

        return value;
    }, [featureName, parentFeatureSecurity?.featureNames]);

    return <FeatureSecurityContext value={contextValue}>{children}</FeatureSecurityContext>;
}
